/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import * as React from "react";
import Dialog from "@mui/material/Dialog";
import "./commonPopUp.scss";

export default function CommonPopUp(props: any) {
  const [open, setOpen] = React.useState(props.openCommonPopup);

  const handleClose = () => {
    setOpen(false);
    props.closePopup(false);
  };

  return (
    <div className="commonWrapper" >
      <Dialog open={open} onClose={handleClose}>
        <div className="popUpMain">
          <div className="popUpeader">
          </div>
          <div className="popUpDetails">
            <span>
              Your temporary password has expired. Kindly contact{" "}
              <a href="mailto:support@infraclear.com" className="emailText">
                {" "}
                support@infraclear.com
              </a>{" "}
              to reset your account.
            </span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}